// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab-root-33kKH","button":"Tab-button-1FPpH","primary":"Tab-primary-BShmJ","active":"Tab-active-XrGkw","secondary":"Tab-secondary-SAOuB"};